import { getMediaLinkPreview } from '../../../api/mediaLinkPreview';

import type { MediaHitResolver } from './types';

/**
 * TREATMENT arm: the metadata behind the Change-owned card.
 *
 * Backed by iframely's `/api/iframely` endpoint, which carries the outlet logo and publish date that
 * `/api/oembed` doesn't. `html` is empty on purpose — the card renders no iframe, so the embed markup
 * is never fetched and `iframely.net/embed.js` is never injected in this arm.
 */
export const resolveMediaHitCard: MediaHitResolver = async ({ url, utilityContext }) => {
	try {
		const card = await getMediaLinkPreview({ url }, utilityContext);
		return { status: 'valid', html: '', card };
	} catch {
		return { status: 'invalid' };
	}
};
